<template>
    <div class="record-warp">
        <div class="search-box">
            <div class="input-box">
                <img class="img" src="@/assets/images/archives/search-icon.png" alt="">
                <input class="input" v-model="searchValue" type="text" placeholder="项目名"
                       placeholder-style="color: #939393;" @input="onInput">
            </div>
        </div>
        <!-- 目前只有项目交付的 nabbar切换不做 -->
        <div class="nabbar-box"></div>
        <div class="record-list">
            <van-list
                v-model="isLoading"
                :finished="finished"
                finished-text="没有更多了"
                :immediate-check="false"
                @load="onUpData"
            >
                <template v-for="(item,index) in arrData">
                    <div class="record-item">
                        <div class="top-box">
                            <div class="name">项目交付档案：{{ item.project_name }}</div>
                            <div class="time">转发时间：{{ item.time }}</div>
                            <div class="share-user">转发人：{{ item.user_name }}</div>
                        </div>
                        <div class="list-box">
                            <template v-for="(list,listIndex) in item.click_lists">
                                <div class="list-item">
                                    <div :class="['phone-box',{'phone-box-red':list.is_self_click != 1}]">
                                        <div class="info red"><span>手机号：</span>{{ list.click_user_phone }}</div>
                                        <div class="info mtop-16 red"><span>点击时间：</span>{{ list.time }}</div>
                                    </div>
                                    <div class="duration-box">
                                        <template v-if="list.is_self_click == 1">
                                            <div v-if="list.bag_score" class="money">+{{ list.bag_score }}元</div>
                                            <div class="info  mtop-10">
                                                <span>时长：</span>{{ list.access_time || 0 }}s
                                            </div>
                                        </template>
                                        <template v-else>
                                            <img class="img" src="@/assets/images/archives/slice-icon.png" alt="">
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-if="arrData.length == 0 && isLoading">
                    <div class="contract_not">
                        <img class="img" src="~@/assets/images/archives/dossier/contract_not.png" alt="">
                        <p>暂无信息</p>
                    </div>
                </template>
            </van-list>
        </div>
    </div>
</template>

<script>


import {getLogBell} from "@/js/archives/dossier.js";
import {List} from "vant";


export default {
    name: "archivesUserRecord",
    components: {
        List
    },
    data() {
        return {
            nPage: 0,
            loading: false,
            finished: false,
            searchValue: '',
            inputTimeout: null,
            arrData: [],
            isLoading: false,
        }
    },
    created() {
        $init(() => {
            this.getLogBellFun();
        })
    },
    methods: {
        getLogBellFun() {
            this.$store.commit('loadSwitch', true)
            getLogBell({
                search_word: this.searchValue,
                page: this.nPage,
                limit: 10
            }).then((res) => {
                let data = res.data.data.result;
                let lists = data.lists || [];
                lists.forEach((it) => {
                    it.time = it.share_date ? it.share_date.replaceAll('-', '.') : '';
                    it.click_lists && it.click_lists.length > 0 && it.click_lists.forEach((list) => {
                        list.time = list.click_time ? list.click_time.replaceAll('-', '.') : '';
                    })
                })
                console.log(lists)
                if (this.nPage == 0) {
                    this.arrData = lists;
                } else {
                    this.arrData.push(...lists);
                }
                if (this.arrData.length == data.total) {
                    this.finished = true;
                }
                this.isLoading = false;
                this.$store.commit('loadSwitch', false)
            })
        },
        onUpData() {
            console.log('onUpData')
            this.nPage = this.nPage + 1;
            this.getLogBellFun();
        },
        onInput(e) {
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout)
                this.inputTimeout = null;
            }
            this.inputTimeout = setTimeout(() => {
                this.nPage = 0;
                this.getLogBellFun();
                this.inputTimeout = null;
            }, 1000)
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'Abel-Regular';
    src: url("/src/assets/font/Abel-Regular.ttf");
}

.record-warp {
    width: 100vw;
    min-height: 100vh;
    padding-top: 32px;
    padding-bottom: env(safe-area-inset-bottom);
    background: #f9f9fb;

    .search-box {
        width: 686px;
        height: 142px;
        background: #FFFFFF;
        border-radius: 16px;
        margin: 0 auto 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        .input-box {
            width: 598px;
            height: 80px;
            background: #F9F9FB;
            border-radius: 16px;
            opacity: 1;
            border: 2px solid #EEEEEE;
            padding: 16px;
            display: flex;
            align-items: center;
        }

        .img {
            width: 48px;
            height: 48px;
            display: block;
            margin-right: 16px;
        }

        .input {
            width: calc(100% - 100px);
            height: 30px;
            font-size: 24px;
            font-family: Abel-Regular, Abel;
            font-weight: 400;
            background: transparent;
            line-height: 30px;
        }
    }

    .record-list {
        .record-item {
            width: 686px;
            background: #FFFFFF;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
            border-radius: 16px;
            margin: 0 auto 32px;

            .top-box {
                width: 100%;
                background: #f3f6ff;
                padding: 20px 32px 28px 52px;
                position: relative;

                .name {
                    font-size: 24px;
                    font-family: Abel-Regular, Abel;
                    color: #333333;
                    line-height: 30px;
                    margin-bottom: 14px;
                }


                .time {
                    font-size: 22px;
                    font-family: Abel-Regular, Abel;
                    color: #A3A3A3;
                    line-height: 26px;
                }

                .share-user {
                    position: absolute;
                    right: 32px;
                    bottom: 28px;
                    font-size: 22px;
                    font-family: Abel-Regular, Abel;
                    color: #333333;
                    line-height: 26px;
                }
            }

            .top-box::after {
                content: '';
                position: absolute;
                top: 26px;
                left: 32px;
                width: 4px;
                height: 26px;
                background: #0D53FC;
            }

            .list-box {
                margin: 0 32px;

                .list-item {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    padding: 30px 0 28px;
                    display: flex;
                    position: relative;
                }

                .list-item:nth-last-child(1) {
                    border: none;
                }

                .phone-box {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-end;

                }


                .info {
                    font-size: 24px;
                    font-family: Abel-Regular, Abel;
                    font-weight: 400;
                    color: #333333;

                    span {
                        color: #A3A3A3;
                    }
                }

                .mtop-16 {
                    margin-top: 16px;
                }

                .mtop-10 {
                    margin-top: 10px;
                }

                .duration-box {
                    margin-left: auto;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: flex-end;

                    .img {
                        width: 48px;
                        height: 48px;
                        display: block;
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                .money {
                    font-size: 32px;
                    font-family: Abel-Regular, Abel;
                    font-weight: 400;
                    color: #E95859;
                    line-height: 40px;
                }

                .phone-box-red {
                    .red {
                        color: #E95859 !important;
                    }

                    span {
                        color: #E95859 !important;
                    }
                }
            }
        }
    }

    .contract_not {

        width: 686px;
        height: calc(100vh - 200px - env(safe-area-inset-bottom));
        background: #FFFFFF;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 16px;
        margin: 0 auto 32px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .img {
            width: 60%;
            display: block;
            margin: 0 auto 32px;
        }

        p {
            font-size: 28px;
            font-family: Alata-Regular, Alata;
            color: $greyText;
            line-height: 33px;
            text-align: center;
        }
    }
}
</style>
